import React from "react";

export default class Footer extends React.Component {
  render() {
    return (
      <footer>
        <aside>
          <p>Sign Awning</p>
          <p>Email: bob@signawning.com</p>
          <p>Phone: 415-386-3333</p>
          <p>iPhone: 415-948-6000</p>
        </aside>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.js